import { KpiTiles } from '../features/overview/KpiTiles';
import { ProjectsCompact } from '../features/overview/ProjectsCompact';
import { LiveActivity } from '../features/live/LiveActivity';

/**
 * Screen 01: the KPI tiles with real numbers (builds today, 7-day success rate), the live activity stream and one
 * compact list of projects. "Now shipping" returns with releases (docs/mvp-plan.md P18); "Needs attention" returns once
 * something feeds it (it was a fixed empty state). Phone order follows the mobile mockup (live activity first).
 */
export function Overview() {
  return (
    <div className="flex min-w-0 flex-col gap-6">
      <KpiTiles />
      <div className="grid min-w-0 gap-6 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)] lg:items-start">
        <LiveActivity className="min-w-0" />
        <ProjectsCompact />
      </div>
    </div>
  );
}
